import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Register from '../pages/account/Register';
import { Styles } from '../pages/account/styles/account';
import { GetApi, PostApi } from '../services/CommonService2';


function LoginModal(props) {
  //   const [show, setShow] = useState(false);
  //   const handleClose = () => setShow(false);
  //   const handleShow = () => setShow(true);

  const [showotp, setShowOtp] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState("")
  const [otp, setOtp] = useState('');
  const [postModal, setPostModal] = useState(false);
  const history = useHistory();
  const [modalShow, setModalShow] = useState(true)







  const saveToken = async (userdata) => {
    var tntId = JSON.parse(localStorage.getItem('tID'))
    localStorage.setItem(`userdata${tntId}`, JSON.stringify(userdata));
    const expiryTime = Date.now() + 3 * 24 * 60 * 60 * 1000;;
    localStorage.setItem(`userdata_expiry${tntId}`, expiryTime.toString());
  }

  const onLogin = async (e) => {
    e.preventDefault()
    const respdata = {
      username: userName,
      tenantid: ''
    }
    const ResponseMessage = await GetApi(respdata, 'LOGIN');

    // console.log("ResponseMessage=", ResponseMessage);

    if (ResponseMessage.data.mobileno) {
      setShowOtp(true);

      toast.success('Otp  sent to your mobile number successfully', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (ResponseMessage.data == 'USER_NOT_FOUND') {
      toast.info('Please kindly register or Login with registered mobile number', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    else if (ResponseMessage.data == 'INACTIVE') {

      toast.error('Your account is inactive ,Please contact admin', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }
    else if (ResponseMessage.data == 'ALREADY_LOGGEDIN') {

      toast.error('You have already logged in with this mobile number , Please kindly logout or contact support team', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }

    // else{
    //   toast.error('Incorrect Mobile number', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     });
    // }
  }


  const verifyOtp = async (e) => {
    e.preventDefault()
    const respdata = {
      username: userName,
      otp: otp
    }
    const ResponseMessage = await GetApi(respdata, 'VERIFY');

    // console.log("Verify OTP data:",ResponseMessage);

    if (ResponseMessage.data == 'OTP_EXPIRED') {

      toast.error('OTP has expired ', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    } else if (ResponseMessage.data == 'INVALID_OTP') {

      toast.error('Invalid otp  ', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    } else {
      await saveToken(ResponseMessage)
      // console.log("OTP worked!!@");
      props.onClose()
      props.login()
      history.push(`${"/"}`)

    }
  }

  function formDetails(event) {

    if (event.target.name === "userName") {
      setUserName(event.target.value)
    }

    if (event.target.name === "password") {
      setPassword(event.target.value)
    }

    // if (event.target.name==="otp"){
    //   setOtp(event.target.value) 
    // }


  }

  const openModal = () => {
    // setPostModal(true)
    setModalShow(true)
    // onClose()


  }
  const closemodal = () => {
    setPostModal(false)
    setModalShow(true)

  }

  const showToggle = () => {

    // console.log("working");

    setModalShow(false)
    setPostModal(true)


  }

  const passLogin = async (e) => {

    e.preventDefault()

    if (userName == '') {

      toast.error('Enter Mobile Number', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }
    else if (password == '') {
      toast.error('Enter Password', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }
    else {
      const respdata = {
        username: userName,
        password: password
      }
      const ResponseMessage = await GetApi(respdata, 'PASSLOGIN');
      console.log("passlogin response", ResponseMessage);
      if (ResponseMessage.data == 'USER_NOT_FOUND') {
        toast.error('User not found ', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else if (ResponseMessage.data == 'INVALIDPASSWORD') {
        toast.error('Invalid password ', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
      else if (ResponseMessage.data == 'INACTIVE') {
        const result = window.confirm('Your account is inactive, please contact admin');
      }
      else if (ResponseMessage.data == 'ALREADY_LOGGEDIN') {
        const result = window.confirm('You have already logged in with this mobile number , Please kindly logout or contact support team');
      }
      else {
        await saveToken(ResponseMessage)
        const now = new Date();
        const offsetIST = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
        const istTime = new Date(now.getTime() + offsetIST).toISOString().slice(0, 19).replace("T", " ");
        const updatereqparam = {
          mobileno: userName,
          lastlogin: istTime,
          ptype: 'UPDATELASTLOGIN',
        };
        const saveuserinfo = await PostApi(updatereqparam, 'SAVEUSERINFO');
        props.onClose()
        props.login()
        // history.push(`${ "/"}`)
        console.log("loginn working!!!!");
        window.location.href = '/'
      }
    }

  }

  const forgotpassword = async () => {
    if (userName == '') {
      toast.error('Enter Mobile Number', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      const respdata = {
        username: userName,
        tenantid: ''
      }
      const ResponseMessage = await GetApi(respdata, 'FORGOTPASSWORD');
      if (ResponseMessage.data == 'USER_NON_EXISTS') {
        toast.error('Invalid mobile number', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        const result = window.confirm('Temporary password has been sent to your registered email id , Please login and change your password');
      }
    }
  }
  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch static backdrop modal
      </Button> */}

      <Modal show={modalShow} // onHide={modalOpen} // backdrop="static"
        keyboard={false}
        style={{ zIndex: 99999, borderRadius:20, }}
      >
        {/* closeButton */}
        <Styles>
          <div class="modal-content shadow-lg rounded border-0">

            <div class="modal-header py-4 border-0">
              <button onClick={props.onClose} type="button" class="btn-close bg-white opacity-100 border border-2 border-warning rounded-circle close-btn"
                onclick="closeModal()">
              </button>
            </div>

            <div class="wave-container">
              <div class="wave wave1"></div>
              <div class="wave wave2"></div>
              <div class="wave wave3"></div>
            </div>

            <div className="modal-body px-4">
              <form>
                <div className="mb-3 text-center">
                  <h5 className="modal-title fs-1 fw-bold">Log In</h5>
                </div>

                <div className="mb-3">
                  <label htmlFor="login_user" className="form-label fw-bold">User</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your email or phone" id="login_user" name='userName' onChange={formDetails} value={userName}
                  />
                  <span className="login_input-msg"></span>

                </div>

                <div className="mb-2">
                  <label htmlFor="login_user" className="form-label fw-bold">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter your password" id="login_password" name='password' onChange={formDetails} value={password}
                  />
                  <span className="login_input-msg"></span>

                </div>

                <div className="d-flex justify-content-end mb-4 py-2">
                  <a href="#" onClick={forgotpassword} className="text-decoration-none text-warning fw-bold hover-link fs-5">Forgot Password?</a>
                </div>

                <button onClick={passLogin} type="submit" className="btn w-100 py-2 fs-4 rounded-pill text-white fw-bold login-btn">Log In</button>

                <div className="d-flex justify-content-center my-3">
                  <p className="mb-0 fs-5">Don't have an account?</p>
                  <a href="#" onClick={showToggle} style={{ textDecorationLine: 'underline', }} className="text-warning ms-2 fw-bold hover-link fs-5">Sign Up</a>
                </div>
              </form>
            </div>
          </div>

        </Styles>

        {/* <Modal.Footer>
          <Button variant="secondary" onClick={props.onClose}>
            Close
          </Button>

        </Modal.Footer> */}
      </Modal>
      {/* <ToastContainer /> */}


      <Modal size="l" show={postModal} >
        <div className="" role="document">
          <div className="">
            <form >
              <div className="modal-header">

                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <Register closemodal={closemodal} loginmodal={openModal} />
              </div>
            </form>

          </div>
        </div>




      </Modal>
    </>
  );
}

export default LoginModal;